module.exports = __webpack_public_path__ + "static/img/ivoice_banner2_phone@2x.dfe93d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/new_home/ivoice_banner2_phone@2x.png
// module id = 500
// module chunks = 0